import { HTTP } from "@/api";

export default {
  fetchAds({ getters, commit }) {
    return new Promise((resolve, reject) => {
      // A-9: право ADS_DISABLED = ad-free; есть право → рекламу не грузим
      if (getters.hasPermission("ADS_DISABLED")) {
        return resolve(true);
      }
      HTTP.get("/score/ads")
        .then(res => {
          let data = res.data;
          if (data && data.success) {
            commit("setAds", data.result);
            resolve(true);
          } else reject(data.message);
        })
        .catch(reject);
    });
  }
};
